import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { EmployeeTypesDto } from "./employee-type-dto";

export class AllEmployeeTypesResponse extends GlobalResponseObject{
    data?: EmployeeTypesDto[];

    /**
     * 
     * @param status
     * @param intlCode
     * @param internalMessage
     * @param data
     */

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: EmployeeTypesDto[]){
        super(status, intlCode, internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}